import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'portal-ui-marketing-consent',
  standalone: true,
  imports: [],
  templateUrl: './marketing-consent.component.html',
  styleUrls: ['./marketing-consent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingConsentComponent {
  @HostBinding('class') private readonly hostClass = 'space-y-2 lg:space-y-4';
}
